import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ProductCard = ({ product, category, categorySlug, brand, brandSlug }) => {
  const defaultImage = 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=400';

  return (
    <Link
      to={`/product/${product.slug}`}
      className="card-product product-card group block"
      data-testid={`product-card-${product.slug}`}
    >
      {/* Image */}
      <div className="aspect-square overflow-hidden bg-[#F4F4F5]">
        <img
          src={product.images?.[0] || defaultImage}
          alt={product.name}
          className="w-full h-full object-cover image-hover"
          loading="lazy"
        />
      </div>

      {/* Content */}
      <div className="p-5">
        {/* Category & Brand */}
        <div className="flex items-center gap-2 mb-2">
          {category && (
            <span className="text-[10px] uppercase tracking-widest text-[#C0C4CC]">
              {category}
            </span>
          )}
          {category && brand && (
            <span className="text-gray-300">|</span>
          )}
          {brand && (
            <span className="text-[10px] uppercase tracking-widest text-gray-400">
              {brand}
            </span>
          )}
        </div>

        {/* Name */}
        <h3 className="heading-sm text-[#0A0A0A] mb-2 group-hover:text-[#C0C4CC] transition-colors">
          {product.name}
        </h3>

        {/* Attributes */}
        <div className="flex flex-wrap gap-2 mb-3">
          {product.volume && (
            <span className="text-xs px-2 py-1 bg-[#F4F4F5] text-gray-600">
              {product.volume}
            </span>
          )}
          {product.product_type && (
            <span className="text-xs px-2 py-1 bg-[#F4F4F5] text-gray-600">
              {product.product_type}
            </span>
          )}
        </div>

        {/* Availability */}
        <div className="flex items-center justify-between">
          <span className={`text-xs ${
            product.availability === 'In Stock' ? 'text-green-600' : 'text-amber-600'
          }`}>
            {product.availability}
          </span>
          <span className="text-xs text-[#C0C4CC] flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
            View Details
            <ArrowRight className="h-3 w-3" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
